import { styled } from 'styled-components';

const StyledPromptForm = styled.form`
  display: flex;
  align-items: flex-end;
  gap: 8px;
  padding: 0 18px;
`;

export default StyledPromptForm;
